import { css } from '@emotion/core'
import { measures } from 'styles/variables'

const { unit, half } = measures

export const form = css`
  text-align: left;
`

export const submitWrapper = css`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const wrapperLabel = css`
  margin-top: ${half}px;
  margin-right: ${half}px;
`

export const wrapperButton = css`
  height: ${unit}px;
`

export const wrapperSwitcher = css`
  display: flex;
  margin-top: ${half}px;
`
